import About from "./aboutUs/aboutUs";
import Home from "./Home";
import Area from "./business/area/Area";
import Result from "./business/result/Result";
import Contact from "./contactUs/coontactUs";
import NotFound from "./NotFound";

const routes = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "abt_overview",
    element: <About tabIndex={0} />,
  },
  {
    path: "abt_history",
    element: <About tabIndex={1} />,
  },
  {
    path: "abt_vision",
    element: <About tabIndex={2} />,
  },
  {
    path: "abt_location",
    element: <About tabIndex={3} />,
  },
  {
    path: "busi_si",
    element: <Area tabIndex={0} />,
  },
  {
    path: "busi_security",
    element: <Area tabIndex={1} />,
  },
  {
    path: "busi_consulting",
    element: <Area tabIndex={2} />,
  },
  {
    path: "rslt_outcome",
    element: <Result tabIndex={0} />,
  },
  {
    path: "rslt_portfolio",
    element: <Result tabIndex={1} />,
  },
  {
    path: "contactUs",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
